import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-220867f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "allFeaturedRatesBox",
  class: "featured-box container-fluid topMargin"
}
const _hoisted_2 = { class: "featured-head row" }
const _hoisted_3 = { class: "col col-xs-12 title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Today's Featured Rates", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "featured-head row" }
const _hoisted_7 = { class: "col col-xs-12 font-style mb-10 title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "featured-rates-body row" }
const _hoisted_10 = {
  key: 0,
  class: "nav-tabs"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "footer" }
const _hoisted_13 = { class: "all-rates-link" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "featured-disclaimer" }, " Sponsors listed are Member FDIC or NCUA insured. ", -1))
const _hoisted_16 = {
  key: 0,
  class: "featured-disclaimer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_da_tooltip = _resolveComponent("da-tooltip")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_how_da_get_paid = _resolveComponent("how-da-get-paid")!
  const _component_ad_disclosure_tooltip = _resolveComponent("ad-disclosure-tooltip")!
  const _component_item = _resolveComponent("item")!

  return (_ctx.itemsRendered)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (_ctx.currentTab.averageRate)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_ctx.currentTab.productId == 34 ? "vs the FDIC 1-yr CD Nat'l Avg:" : "vs. the FDIC Nat'l Avg:") + " ", 1),
                  _createVNode(_Transition, {
                    name: "component-fade",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("span", {
                        key: _ctx.currentTab.key
                      }, _toDisplayString(_ctx.$filters.percentageFilter(_ctx.currentTab.averageRate)) + " APY ", 1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_da_tooltip, {
                    class: _normalizeClass(["apy-tooltip-span", _ctx.apyTooltipIconCSSClass]),
                    iconVersion: _ctx.iconVersion,
                    title: _ctx.apyTitleText
                  }, null, 8, ["class", "iconVersion", "title"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_font_awesome_icon, {
            class: "trophy-icon",
            size: "lg",
            icon: ['fas', 'trophy-alt']
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_how_da_get_paid),
            _hoisted_8,
            _createVNode(_component_ad_disclosure_tooltip)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.tabs.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, tabIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["col-sm tab-name", ['tab-button', { active: _ctx.currentTab.name === tab.name }]]),
                    key: tab.key,
                    onClick: _withModifiers(($event: any) => (_ctx.tabClick(tab, tabIndex)), ["prevent"])
                  }, _toDisplayString(tab.name), 11, _hoisted_11))
                }), 128)),
                _createElementVNode("hr", {
                  class: "active-tab-hr",
                  ref: "activeTabHr",
                  style: _normalizeStyle(_ctx.activeTabHrCss)
                }, null, 4)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_TransitionGroup, {
            name: "all-featured-rates-list",
            tag: "table",
            class: "table all-featured-rates-list",
            style: _normalizeStyle(_ctx.listCss)
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("tbody", {
                ref: "listBody",
                key: _ctx.currentTab.key
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTab.ads, (ad) => {
                  return (_openBlock(), _createBlock(_component_item, {
                    key: ad.id,
                    ad: ad
                  }, null, 8, ["ad"]))
                }), 128))
              ]))
            ]),
            _: 1
          }, 8, ["style"]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h4", _hoisted_13, [
              _createVNode(_Transition, {
                name: "component-fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("a", {
                    key: _ctx.currentTab.key,
                    href: _ctx.currentTab.url
                  }, "Compare All Rates >", 8, _hoisted_14))
                ]),
                _: 1
              })
            ]),
            _hoisted_15,
            (_ctx.isBonusAmountExists)
              ? (_openBlock(), _createElementBlock("h6", _hoisted_16, " * Certain restrictions and conditions may apply. See bank website for more details. "))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}